import { render, staticRenderFns } from "./ModalOrdenOpcion.vue?vue&type=template&id=10a79a36"
import script from "./ModalOrdenOpcion.vue?vue&type=script&lang=js"
export * from "./ModalOrdenOpcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports